import Fond from'../../assets/presentation.png'

import './presentation.sass'

const Presentation = () => {
    return (
        <div className='presentation' id='presentation'>
            <img className='presentation__img' src={Fond} alt="" />
            <div className='presentation__container'>
                <h2 className='presentation__container__title'>Vous conseiller est notre métier</h2>
                <p className='presentation__container__para'>S’adressant autant aux particuliers qu’aux entreprises, nous gérons de nombreuses PE-TPE en Isère (notamment dans le Vercors), ainsi que des institutionnels (mairies, communautés de communes), mais aussi des artisans, professions libérales…</p>
                {/* <br/> */}
                <p className='presentation__container__para'>Nous intervenons rapidement sur toutes les villes du bassin Grenoblois. Contrôles distants et téléassistances nous permettent d’accompagner de nombreuses entreprises et particuliers en france et à l’étranger.</p>
                <button className='presentation__container__btn'>En savoir plus</button>
            </div>
        </div>
    )
}

export default Presentation